import { api } from "@/frontend/services/api";
import type {
  CreateFixtureStatusRequestDTO,
  UpdateFixtureStatusRequestDTO,
  FixtureStatusResponseDTO,
  FixtureStatusesPaginatedResponseDTO,
  ApiResponse,
  PaginationRequestDTO,
} from "@/shared/dto";

const BASE_URL = "/fixture-statuses/private";

export const fixtureStatusService = {
  getPaginate: (params?: PaginationRequestDTO) => {
    return api.getWithParams<ApiResponse<FixtureStatusesPaginatedResponseDTO>>(BASE_URL, params);
  },
  getById: (id?: string) =>
    api.get<ApiResponse<FixtureStatusResponseDTO>>(`${BASE_URL}/${id}`),
  create: (data: CreateFixtureStatusRequestDTO) =>
    api.post<ApiResponse<FixtureStatusResponseDTO>>(BASE_URL, data),
  update: (id: string, data: UpdateFixtureStatusRequestDTO) =>
    api.put<ApiResponse<FixtureStatusResponseDTO>>(`${BASE_URL}/${id}`, data),
  delete: (id: string) => api.delete<ApiResponse<void>>(`${BASE_URL}/${id}`),
};
